export const WON_TENDERS_LOAD_DETAILS_DATA = 'WON_TENDERS_LOAD_DETAILS_DATA'
export const WON_TENDERS_LOAD_DETAILS_DATA_REQUEST = (entId, tenderId) =>
    `WON_TENDERS_LOAD_DETAILS_${entId}_${tenderId}_DATA_REQUEST`
export const WON_TENDERS_DETAILS_TABLE_LOADING_TRUE = 'WON_TENDERS_DETAILS_TABLE_LOADING_TRUE'
export const WON_TENDERS_DETAILS_TABLE_LOADING_FALSE = 'WON_TENDERS_DETAILS_TABLE_LOADING_FALSE'
export const WON_TENDERS_DETAILS_TABLE_LOADING_FAILED = 'WON_TENDERS_DETAILS_TABLE_LOADING_FAILED'
export const WON_TENDERS_DETAILS_TABLE_DATA_RECEIVED = 'WON_TENDERS_DETAILS_TABLE_DATA_RECEIVED'
